module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABmUExURf////n5+f39/ejo6AAAAAAAAOjo6AAAAAAAAP7+/vn5+QAAAIuLi/z8/ICAgPPz8+np6S0tLfr6+ikpKQAAAPPz86mpqdPT0+vr6wAAAJSUlOLi4v///xEREU5OTqCgoERERBwcHKa3AMEAAAAcdFJOU/6Y16MYEf4CBPTbCwu/DMYvIpIlFJZBNJsgSqFSgLQ7AAAAi0lEQVQY02WP2Q7CMAwENxdx0vukh9sk//+TVBVQKuZtR7K9hrWW6lY6J9uajgBLuQCfQORkQWXBCDGlGMBFSSDBj3072R8sCE/gnQ+DIw4cti+BB0iOl4gs4ThdIrH7F/4+4jHdl04Y72dHaPVbTGn0TXVVr5oeRnfq85zqtEFm9Lys3jm/LrM22QsJgBUzTqbeqwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/semantic/dist/themes/fibrestream/assets/images/oval_black.png
// module id = 494
// module chunks = 0